/// <reference path="../app.js"/>

$('.content-slider').slick({
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay:true,
    autoplaySpeed:10000,
	dots: true,
	prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
	nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
	responsive: [
	  {
		breakpoint: 500,
		settings: {
			arrows: false
		}
	  },
	]
});

// On before slide change
$('.featureslider').on('init', function(event, slick){
    var self = $(this);
    console.log('ready');
    self.find('.feature-slide').addClass('ready');
});


$('.featureslider').each(function() {
    var self = $(this);
    var autoplay = self.data('autoplay');
    if (self.find('.feature-slide').length > 1) {
        self.slick({
        	infinite: autoplay,
            fade: true,
        	slidesToShow: 1,
        	slidesToScroll: 1,
        	autoplay:autoplay,
        	dots: true,
            arrows:false
        });
    } else {
        setTimeout(function() {
            self.addClass('ready');
        },350);
    }
});

$('.product-slider').slick({
	infinite: true,
	slidesToShow: 4,
	slidesToScroll: 1,
	autoplay:true,
	dots: false,
    arrows:false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
});

function onPlayerReady(e) {
    console.log("Player Ready");
    var player = YT.get('youtube-player');
    player.playVideo();
}

function pushProgress(p,t,v) {
    console.log('progress:'+p);
    console.log('time:'+t);
    console.log(v);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'gtm.video',
        'gtm.videoProvider': 'Vimeo',
        'gtm.videoStatus': 'progress-'+p,
        'gtm.videoUrl': v.Url,
        'gtm.videoTitle': v.Title,
        'gtm.videoDuration': v.Duration,
        'gtm.videoCurrentTime': t,
        'gtm.videoVisible': true,
    });
}

$(document).on('click', '.image-grid-video, .video-tile', function() {

    var id = $(this).data('video');
    var type = $(this).data('video-type');
    var modal = $('#video-embed');
    var ytPlayer;

    if (type == 'vimeo') {
        var embed = '<iframe id="vimeo-player" width="800" height="500" src="https://player.vimeo.com/video/'+ id +'?autoplay=1&api=1&player_id=vimeo-player" frameborder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';
        // populate and open video modal
        modal.find('.video-wrap').html(embed);

        var iframe = $('#vimeo-player')[0];
        var player = new Vimeo.Player(iframe);
        var vidTitle,
            vidUrl,
            vidDuration,
            quarterComplete = false,
            halfComplete = false,
            threeQuarterComplete = false;

        player.on('play', function(data) {
            var time = Math.round(data.seconds);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'gtm.video',
                'gtm.videoProvider': 'Vimeo',
                'gtm.videoStatus': 'start-'+time,
                'gtm.videoUrl': vidUrl,
                'gtm.videoTitle': vidTitle,
                'gtm.videoDuration': vidDuration,
                'gtm.videoCurrentTime': time,
                'gtm.videoVisible': true,
            });

        });

        player.getVideoTitle().then(function(title) {
            vidTitle = title;
        });
        player.getVideoUrl().then(function(url) {
            vidUrl = url;
        });
        player.getDuration().then(function(d) {
            vidDuration = d;
        });

        player.on('pause', function(data) {
            var time = Math.round(data.seconds);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'gtm.video',
                'gtm.videoProvider': 'Vimeo',
                'gtm.videoStatus': 'pause-'+time,
                'gtm.videoUrl': vidUrl,
                'gtm.videoTitle': vidTitle,
                'gtm.videoDuration': vidDuration,
                'gtm.videoCurrentTime': time,
                'gtm.videoVisible': true,
            });
        });

        player.on('ended', function(data) {
            var v = {Title:vidTitle, Duration:vidDuration, Url: vidUrl};
            pushProgress('100',vidDuration,v);
        });

        player.on('timeupdate', function(data) {
            var progress = Math.round(data.percent*100);
            var t = Math.round(data.seconds);
            var v = {Title:vidTitle, Duration:vidDuration, Url: vidUrl};
            switch (progress) {
                case 25:
                    if (!quarterComplete) {pushProgress('25',t,v); quarterComplete=true;};
                    break;
                case 50:
                    if (!halfComplete) {pushProgress('50',t,v); halfComplete=true;};
                    break;
                case 75:
                    if (!threeQuarterComplete) {pushProgress('75',t,v); threeQuarterComplete=true;};
                    break;
                default:

            }
        });

    } else if (type == 'youtube') {
        var embed = '<iframe id="youtube-player" width="560" height="315" src="https://www.youtube.com/embed/'+id+'?enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';

        // populate and open video modal
        modal.find('.video-wrap').html(embed);

        // init yt player api
        ytPlayer = new YT.Player('youtube-player', {
            events: {
                'onReady': onPlayerReady
            }
        });
    }

    modal.foundation('open');

});


// $.fn.inView = function(){
//     //Window Object
//     var win = $(window);
//     //Object to Check
//     var obj = $(this);
//     //the top Scroll Position in the page
//     var scrollPosition = win.scrollTop();
//     //the end of the visible area in the page, starting from the scroll position
//     var visibleArea = win.scrollTop() + win.height();
//     //the end of the object to check
//     var objEndPos = (obj.offset().top + obj.outerHeight());
//     return(visibleArea >= objEndPos && scrollPosition <= objEndPos ? true : false)
// };

// $(".image-grid-row").each(function() {
//     if ($(this).inView()) {
//         $(this).addClass('visible');
//     }
// });
//
// $(window).scroll(function(){
//     $(".image-grid-row").each(function() {
//         if ($(this).inView()) {
//             $(this).addClass('visible');
//             console.log('adding')
//         }
//     });
// });
